import { IonIcon, IonButton, IonSpinner, IonRippleEffect } from "@ionic/react";
import { chevronForwardOutline, saveOutline, closeCircleOutline } from "ionicons/icons";

// The /app/settings design system, shared by the admin settings pages:
// shadow card, card title, icon row with a right-slot control and an
// expandable area below, plus the admin-only Save footer.

export const cardStyle = {
  backgroundColor: "var(--ion-card-background)",
  borderRadius: 12,
  overflow: "hidden",
  boxShadow: "rgba(0,0,0,0.18) 0 4px 24px",
};

export const cardTitle = {
  fontSize: "1rem", fontWeight: 700,
  color: "var(--ion-text-color)",
  padding: "14px 20px 12px",
};

export const toggleStyle = { "--handle-width": "20px", "--handle-height": "20px" };

// Compact fields that sit in a row's right slot, and full-width ones for the
// expandable area under a row — the standard admin Ionic field either way.
export const FIELD = { className: "admin-field", mode: "md", fill: "outline" };
export const FLOAT = { ...FIELD, labelPlacement: "floating" };
export const rightField = { width: 130, flexShrink: 0, marginLeft: 12 };

export function Chevron() {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: 0, flexShrink: 0, fontSize: 18, color: "var(--ion-color-medium)" }}>
      <IonIcon icon={chevronForwardOutline} style={{ fontSize: "inherit", color: "inherit", pointerEvents: "none" }} />
    </span>
  );
}

export function IconWrap({ icon }) {
  return (
    <div style={{ width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginBottom: 14 }}>
      <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: 0, flexShrink: 0, fontSize: 17, color: "var(--ion-color-medium)" }}>
        <IonIcon icon={icon} style={{ fontSize: "inherit", color: "inherit", pointerEvents: "none" }} />
      </span>
    </div>
  );
}

export function Row({ icon, label, sub, right, below, last, clickable, onClick }) {
  return (
    <div
      onClick={onClick}
      className={clickable ? "ion-activatable" : undefined}
      style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 0 0 20px", cursor: clickable ? "pointer" : "default", position: clickable ? "relative" : undefined, overflow: clickable ? "hidden" : undefined }}
    >
      {clickable && <IonRippleEffect />}
      {icon && <IconWrap icon={icon} />}
      <div style={{
        flex: "1 1 0%", display: "flex", flexDirection: "column",
        paddingBottom: 14, paddingRight: 20,
        borderBottom: last ? "none" : "1px solid var(--ion-border-color)",
        minWidth: 0,
      }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ flex: "1 1 0%", fontSize: "0.9rem", fontWeight: 500, color: "var(--ion-text-color)", minWidth: 0 }}>
            {label}
            {sub && <div style={{ fontSize: "0.78rem", fontWeight: 400, color: "var(--ion-color-medium)", marginTop: 3, lineHeight: 1.4 }}>{sub}</div>}
          </span>
          {right}
        </div>
        {below && <div style={{ marginTop: 10 }}>{below}</div>}
      </div>
    </div>
  );
}

// Muted section label inside a card (the "What's New" label treatment)
export function GroupLabel({ children }) {
  return (
    <div style={{ padding: "12px 20px 0", fontSize: "0.78rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--ion-color-medium)" }}>
      {children}
    </div>
  );
}

// Card footer: status line + Save. Cards that auto-save pass no onSave and
// just show the status.
export function CardFooter({ msg, onSave, saving, label = "Save", icon = saveOutline }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: onSave ? "10px 12px 10px 20px" : "0 20px 14px", borderTop: onSave ? "1px solid var(--ion-border-color)" : "none", minHeight: onSave ? 52 : undefined }}>
      <span style={{ flex: "1 1 0%", minWidth: 0, fontSize: "0.8rem", lineHeight: 1.4, color: msg ? (msg.type === "success" ? "var(--ion-color-success)" : "var(--ion-color-danger)") : "var(--ion-color-medium)" }}>
        {msg ? msg.text : ""}
      </span>
      {onSave && (
        <IonButton size="small" onClick={onSave} disabled={saving} style={{ margin: 0, flexShrink: 0 }}>
          {saving
            ? <IonSpinner name="crescent" style={{ width: 14, height: 14, marginRight: 6 }} />
            : <IonIcon icon={icon} style={{ marginRight: 6 }} />}
          {label}
        </IonButton>
      )}
    </div>
  );
}

export function RemoveButton({ onClick, title = "Remove" }) {
  return (
    <IonButton fill="clear" color="medium" size="small" onClick={onClick} title={title} style={{ margin: 0, marginLeft: 8, flexShrink: 0, "--padding-start": "4px", "--padding-end": "4px" }}>
      <IonIcon slot="icon-only" icon={closeCircleOutline} />
    </IonButton>
  );
}
